// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){


    //wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function(e){

        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(SplitText);

        // split elements with the class "split" into words and characters
        let split = SplitText.create("#Hero-template--26274025439522__hero_jVaWmY h1", { type: "words, chars" });
        gsap.set('#Hero-template--26274025439522__hero_jVaWmY h1', { opacity:1 });
        // now animate the characters in a staggered fashion
        gsap.from(split.words, {
        duration: 1, 
        y: 100,       // animate from 100px below
        autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
        stagger: 0.05, // 0.05 seconds between each 
        onComplete: () => {
            gsap.to('div#Hero-template--26274025439522__hero_jVaWmY p', {
            duration: 1, 
            y: 0,       
            opacity: 1, 
            });
        },
        });

        gsap.from('div#shopify-section-template--26274025439522__section_qyzkJi .group-block',{
			 opacity:0,
			 y:100,
			 duration:3,
             stagger: {
                from: "random",
                amount: 1
            }, // stagger start times
			 scrollTrigger: {
				 trigger: "div#shopify-section-template--26274025439522__section_qyzkJi",
				 scroller: "body",
				 //markers: true,
				 start: "top 50%",
				 end: "top 10%",
				 scrub:true,
			 },
		 });

         gsap.from('.home-how-you-boat-section .swiper',{
			 opacity:0,
			 duration:2,
			 scrollTrigger: {
				 trigger: ".home-how-you-boat-section",
				 scroller: "body",
				 //markers: true,
				 start: "top 50%",
				 end: "top 10%",
				 scrub:true,
			 },
		 });

         gsap.set('.swiper-cards-tags-subtext p', {   
            opacity: 0, 
            });
         // split elements with the class "split" into words and characters
        let split2 = SplitText.create(".home-built-for-every-section h2", { type: "words, chars" });
        // now animate the characters in a staggered fashion
        gsap.from(split2.words, {
        duration: 2, 
        x: 100,       // animate from 100px below
        autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
        stagger: 0.5, // 0.05 seconds between each 
        scrollTrigger: {
            trigger: ".home-built-for-every-section",
            scroller: "body",
            //markers: true,
            start: "top 50%",
            end: "top 10%",
            scrub:true,
        },
        onComplete: () => {
            gsap.to('.swiper-cards-tags-subtext p', {
            duration: 1,     
            opacity: 1, 
            });
        },
        });

        //From Chalky to Chromelike in Three Steps section
        gsap.from('div#shopify-section-template--26274025439522__section_BGnMBD .group-block',{
			 opacity:0,
             scale:0,
			 y:100,
			 duration:3,
             stagger: 1, // stagger start times
			 scrollTrigger: {
				 trigger: "div#shopify-section-template--26274025439522__section_BGnMBD",
				 scroller: "body",
				 //markers: true,
				 start: "top 50%",
				 end: "top 10%",
				 scrub:true,
			 },
		 });

         let split3 = SplitText.create("div#shopify-section-template--26274025439522__section_dwGKpL h2", { type: "words, chars, lines" });
        // now animate the characters in a staggered fashion
        gsap.from(split3.lines, {
        duration: 1, 
        x: -100,       // animate from 100px below
        autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
        stagger: 0.5, // 0.05 seconds between each 
        scrollTrigger: {
            trigger: "div#shopify-section-template--26274025439522__section_dwGKpL",
            scroller: "body",
            //markers: true,
            start: "top 50%",
            end: "top 10%",
            scrub:true,
        },
        });

        gsap.set('.text-block--AMXdVSWRSQUQ3NFVmM__text_i463xt', {  
            opacity: 0,
            scale: 0, 
        });
        gsap.from('.text-block--AQ2RRQXBsMkNaRlY5N__text_hDaEVi,.text-block--AZGdIQTlmdWJyWXpqb__text_i6k4qJ', {
        duration: 1, 
        y: 100,       // animate from 100px below
        autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
        stagger: 0.5, // 0.05 seconds between each 
        scrollTrigger: {
            trigger: "div#shopify-section-template--26274025439522__section_dwGKpL",
            scroller: "body",
            //markers: true,
            start: "top 40%",
            end: "top 0%",
            scrub:true,
        },   
        });
        gsap.to('.text-block--AMXdVSWRSQUQ3NFVmM__text_i463xt', {
        duration: 1,  
        scale: 1,    
        opacity: 1, 
        scrollTrigger: {
            trigger: "div#shopify-section-template--26274025439522__section_dwGKpL",
            scroller: "body",
            //markers: true,
            start: "top 40%",
            end: "top 0%",
            scrub:true,
        },
        });
         
        gsap.set('.text-block--AVGtEVFFHNHk2ZDR6U__text_W4f4yh', {
        opacity: 0, 
        x:100,
        });
        let split4 = SplitText.create(".text-block--ANWh0d3lBdDBFM1hkU__text_NQ3Fey h2", { type: "words, chars, lines" });
        gsap.from(split4.words, {
        duration: 1, 
        x: -100,       // animate from 100px below
        autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
        stagger: 0.5, // 0.05 seconds between each 
        scrollTrigger: {
            trigger: "div#shopify-section-template--26274025439522__section_MAEQgx",
            scroller: "body",
            //markers: true,
            start: "top 80%",
            end: "top 40%",
            scrub:true,
        },  
        });
        gsap.to('.text-block--AVGtEVFFHNHk2ZDR6U__text_W4f4yh', {
        duration: 1,     
        opacity: 1, 
        x:0,
        scrollTrigger: {
            trigger: "div#shopify-section-template--26274025439522__section_MAEQgx",
            scroller: "body",
            //markers: true,
            start: "top 80%",
            end: "top 40%",
            scrub:true,
        },  
        });



    }, false);

});
